import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'

export default [
    {
        path: '/active-session',
        name: 'errors.active-session',
        view: 'errors/ActiveSession',
        middlewares: [RequireUserMiddleware],
    },
]
